let model = {};

// dữ liệu form
model.dataForm = {
    "code": undefined, // required, minLength: 1 - Mã icon
    "file_id": undefined, // required, ref: mushroom_file - Mã file ảnh
};
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "code",
  defaultSort: ["code", "ascending"],
  fields:
    "id, code, file_id",
  filters: "",
  dataSearch: {
    value: {
      code: "",
    },
    operator: {
      code: ":regex_i:",
    },
  },
};
export default model;
